import { render, staticRenderFns } from "./ModalDescontosPrestador.vue?vue&type=template&id=46b575f5"
import script from "./ModalDescontosPrestador.vue?vue&type=script&lang=ts"
export * from "./ModalDescontosPrestador.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports